export { HomePage, GetStuff } from "./homepage/index";
export { LoginPage } from "./login/index";
export { GenresPage } from "./genrespage/index";
export { SearchPage } from "./searchpage";
export { ListPage } from "./mylistspage";
export { AccountPage } from "./accountpage";
